module.exports = __webpack_public_path__ + "img/home.e1fb935c.png";